<template>
  <div
    v-if="!getQueryString('saleCombineIds') && !state.packageId"
    class="goods-status"
    :class="{
      'super-color': superLevel || billionLevel,
      'usually-color': !superLevel && (priceStatus == 2 || priceStatus == 3),
      'special-color': !superLevel && priceStatus == 1
    }"
  >
    <!-- 优惠券过期提示 -->
    <div
      v-if="couponTipContent"
      v-zpm="{
        sortname: '券后价到期提醒',
        sortid: 3,
        areaexposure: 105,
        legoareabackup: { sortName: '券后价到期提醒', sortId: 3 }
      }"
      class="coupon-tip"
      @click="toggleCoupon"
    >
      <img
        class="icon_couponTipContent"
        :src="
          $setPicSize(
            'https://pic5.zhuanstatic.com/zhuanzh/f787d5bd-b92a-4374-8682-52750ead2f0b.png',
            20
          )
        "
        alt=""
      />
      <span>{{ couponTipContent }}</span>
      <img
        class="icon_arrow"
        :src="
          $setPicSize(
            'https://pic3.zhuanstatic.com/zhuanzh/d6bfaa84-e9bd-49e0-b796-8f8698446774.png',
            20
          )
        "
        alt=""
      />
    </div>
    <div v-if="superLevel && billionLevel" class="billion-icon">十亿补贴</div>
    <!-- 红包， 命中十亿补贴不展示红包领券入口 -->
    <div
      v-if="(priceStatus == 3 || (priceStatus == 1 && superLevel)) && !billionLevel"
      v-zpm="{
        sortname: '普通领券',
        sortid: 2,
        areaexposure: 105,
        legoareabackup: { sortName: '普通领券', sortId: 2 }
      }"
      class="coupon-wrapper"
    >
      <ul
        v-if="blendCoupons && blendCoupons.length > 0"
        class="coupon-content"
        @click="toggleCoupon"
      >
        <template v-for="(item, index) in blendCoupons">
          <li v-if="index < 1 && item.type == 'newUser'" :key="'newUserblendCoupons' + index">
            新人限时 | {{ item.text }}
          </li>
          <li v-if="index < 1 && item.type == 'charge'" :key="'chargeblendCoupons' + index">
            {{ Number(item.price / 100) }}元券 | {{ item.text }}
          </li>
          <li v-if="index < 1 && item.type == 'free'" :key="'freeblendCoupons' + index">
            {{ item.text }}
          </li>
        </template>
        <span class="receive">{{ couponTipContent ? '领' : '领取' }}</span>
      </ul>
    </div>

    <div v-if="!superLevel & !billionLevel" class="seckill-container">
      <!-- 红包+秒杀 | 秒杀  -->
      <div
        v-if="priceStatus == 1 || priceStatus == 2"
        class="seckill-wrapper"
        :class="{ 'seckill-wrapper__super': priceStatus == 2 }"
      >
        <seckill-component
          :countDownTime="countDownTime"
          :countDownDesc="countDownDesc"
          @finish="countDownFinish"
        >
        </seckill-component>

        <div
          v-if="priceStatus == 1"
          v-zpm="{
            sortname: '秒杀领券',
            sortid: 1,
            areaexposure: 105,
            legoareabackup: { sortName: '秒杀领券', sortId: 1 }
          }"
          class="equation"
          zz-sortname="到手价"
          @click="toggleCoupon"
        >
          <span>原价<em>&yen;</em>{{ handPriceVo.priceCent / 100 }}</span>
          <span class="reduce">-</span>
          <span>秒杀<em>&yen;</em>{{ handPriceVo.promotionDownPriceCent / 100 }}</span>
          <span class="reduce">-</span>
          <span>红包<em>&yen;</em>{{ handPriceVo.couponDownPriceCent / 100 }}</span>
          <span class="receive-coupons">领券</span>
        </div>

        <div v-if="styleType == 3 && (isShow || tagInfo) && title" class="old-to-new__content">
          <old2new-subsidy
            :class="{
              'style-type-3': !superLevel && priceStatus == 1,
              'old-super-color': superLevel
            }"
            :textVersion="couponTipContent ? 2 : 1"
            :productId="state.infoId"
            :superColor="superLevel"
            :styleType="styleType"
            :metric="state.metric"
            @isShow="show"
          />
          <div v-if="isShow && tagInfo" class="dashed"></div>
          <!-- 金融分期 -->
          <div
            v-if="tagInfo && Object.keys(tagInfo).length"
            v-zpm="{
              sortname: '金融分期',
              sortid: 4,
              areaexposure: 105,
              legoareabackup: { sortName: '金融分期', sortId: 4 }
            }"
            class="tag-info"
            @click="checkFinance(tagInfo.clickUrl)"
          >
            <span class="tag-name">{{ tagInfo.tagName }}</span>
            <span class="receive">抢</span>
            <img
              class="right-icon"
              :src="$setPicSize('9ac58ef3-2f58-4aec-82ad-fd6a8cdba4f8.png')"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <!-- styleType: c2b兼容以旧换新的样式，蓝湖地址https://lanhuapp.com/web/#/item/project/stage?pid=6d6c6c40-66e2-4f14-95ce-ff6225bd10d6&image_id=46d514f8-5082-4a8c-8f14-8aa94a84f6f0&tid=6b40b410-618f-4be8-acea-f5a290aee525 -->
    <template v-if="styleType !== 3 && title">
      <old2new-subsidy
        :class="{
          'style-type-3': !superLevel && priceStatus == 1,
          'old-super-color': superLevel
        }"
        :productId="state.infoId"
        :superColor="superLevel"
        :styleType="styleType"
        :metric="state.metric"
        :textVersion="couponTipContent ? 2 : 1"
      />
      <!-- 金融分期 -->
      <div
        v-if="tagInfo && Object.keys(tagInfo).length"
        v-zpm="{
          sortname: '金融分期',
          sortid: 4,
          areaexposure: 105,
          legoareabackup: { sortName: '金融分期', sortId: 4 }
        }"
        class="tag-info"
        @click="checkFinance(tagInfo.clickUrl)"
      >
        <span class="tag-name">{{ tagInfo.tagName }}</span>
        <span class="receive">抢</span>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { computed, defineComponent, ref, watch } from '@vue/composition-api'
import { state, setState } from '@/store/index'
import seckillComponent from './seckill-component'
import { getQueryString } from '@utils/index'
import { Old2newSubsidy } from '@zz-yp/bm-ui'
import { useDecorator } from '@/lib/useDecorator'
import { login } from '@/lib/decorator/login'
import { skipToUrl } from '@utils/native'
// sortId：0--点击（以旧换新） 1--秒杀领券 2--普通领券 3--券后价到期提醒 4--发条分期
Vue.use(Old2newSubsidy)
export default defineComponent({
  components: {
    seckillComponent
  },
  props: {
    title: {
      // 用来让以旧换新模块在baseInfo接口返回之后请求，因为以旧换新模块需要用到baseInfo接口返回的数据
      type: String,
      default: ''
    },
    priceStatus: {
      type: Number,
      default: 0
    },
    countDownTime: {
      type: Number,
      default: 0
    },
    countDownDesc: {
      type: String,
      default: ''
    },
    billionLevel: {
      type: Boolean,
      default: false
    },
    handPriceVo: {
      type: Object,
      default: () => {}
    },
    superLevel: {
      type: Boolean,
      default: false
    },
    // 金融分期模块
    tagInfo: {
      type: Object,
      default: () => {}
    },
    // 优惠券过期提示文案
    couponTipContent: {
      type: String,
      default: () => ''
    }
  },
  setup(props, ctx) {
    const blendCoupons = ref([])
    const isShow = ref(false)
    //  props.priceStatus  0 无 | 1 红包 + 秒杀 | 2 秒杀 | 3 红包  | 4 大促样式
    const styleType = computed(() => {
      if (props.superLevel || props.billionLevel) {
        return 4
      } else {
        switch (props.priceStatus) {
          case 3:
            return 1
          case 2:
            return 2
          case 1:
            return 3
          default:
            return 1
        }
      }
    })

    /**比较函数 */
    const compare = (property) => {
      return function (a, b) {
        const value1 = a[property]
        const value2 = b[property]
        return value2 - value1
      }
    }

    const calculateCouponList = () => {
      const { coupons, couponsCharged, couponsNewUser, newUserCouponPendant } = state
      //初始化数据置空, 防止数据重复
      blendCoupons.value = []
      // 所有类型的红包按照优惠面额大小排序
      coupons &&
        coupons.length &&
        blendCoupons.value.push({
          discountMoney: coupons[0].discountMoney,
          text: coupons[0].text,
          type: 'free',
          status: coupons[0].status
        })
      couponsCharged &&
        couponsCharged.length &&
        blendCoupons.value.push({
          price: couponsCharged[0].price,
          discountMoney: couponsCharged[0].discountMoney,
          text: couponsCharged[0].text,
          type: 'charge',
          status: couponsCharged[0].status
        })

      if (couponsNewUser) {
        for (let i = couponsNewUser.length - 1; i >= 0; i--) {
          blendCoupons.value.unshift({
            price: couponsNewUser[i].price,
            discountMoney: couponsNewUser[i].discountMoney,
            text: couponsNewUser[i].text,
            type: 'newUser',
            status: couponsNewUser[i].status
          })
        }
      }

      if (newUserCouponPendant) {
        for (let i = newUserCouponPendant.length - 1; i >= 0; i--) {
          blendCoupons.value.unshift({
            price: newUserCouponPendant[i].price,
            discountMoney: newUserCouponPendant[i].discountMoney,
            text: newUserCouponPendant[i].text,
            type: 'newUser',
            status: newUserCouponPendant[i].status
          })
        }
      }

      blendCoupons.value = blendCoupons.value.sort(compare('discountMoney'))
    }

    //红包弹框
    const toggleCoupon = useDecorator(() => {
      setState({
        isShowCouponPop: true
      })
    }, login)

    watch(
      state,
      () => {
        calculateCouponList()
      },
      {
        deep: true,
        immediate: true
      }
    )

    function countDownFinish() {
      ctx.emit('finish')
    }

    const checkFinance = useDecorator((url) => {
      if (url) {
        skipToUrl({
          targetUrl: url
        })
      }
    }, login)

    const show = (data) => {
      isShow.value = data
    }

    return {
      state,
      blendCoupons,
      toggleCoupon,
      countDownFinish,
      getQueryString,
      checkFinance,
      styleType,
      show,
      isShow
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

.goods-status {
  display: flex;
  box-sizing: border-box;
  margin-top: 18px;
  margin-right: 24px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  background: #f8f8f8;

  &::-webkit-scrollbar {
    display: none;
  }
  &.super-color {
    // display: flex;
    // flex-wrap: wrap;
    align-items: center;
    margin-top: 0;
    margin-right: 0;
    background: none;
    .billion-icon {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 36px;
      margin-right: 8px;
      color: #ffffff;
      font-weight: 300;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;

      &::after {
        @include hairline(#fff);
        border-width: 1px;
        border-radius: 8px;
        opacity: 0.35;
      }
    }
    .coupon-wrapper {
      &::after {
        @include hairline(#ff9f99);
        border-width: 1px;
        border-radius: 8px;
        opacity: 1;
      }
      .coupon-content {
        color: #fff;
      }
    }

    .tag-info {
      color: #fff;
      &::after {
        @include hairline(#fff);
        border-width: 1px;
        border-radius: 8px;
        opacity: 0.35;
      }
    }
  }

  &.usually-color {
    display: flex;
  }
  &.special-color {
    display: flex;
    flex-wrap: wrap;
    .seckill-container {
      flex-basis: 100%;
    }
  }

  .coupon-wrapper {
    position: relative;
    display: inline-block;
    height: 36px;
    margin-right: 8px;
    &::after {
      @include hairline(#ff9f99);
      border-width: 1px;
      border-radius: 8px;
      opacity: 0.35;
    }
    .coupon-content {
      display: inline-flex;
      align-items: center;
      height: 100%;
      color: #ff483c;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      > li {
        padding: 0 12px;
        font-family: PingFangSC-Light, PingFang SC;
      }

      .receive {
        position: relative;
        display: flex;
        align-items: center;
        height: 20px;
        padding: 0 12px;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        &::after {
          @include hairline(#ffcfc1);
          border-left-width: 1px;
          border-left-style: dashed;
        }
      }
    }
  }

  .seckill-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    // margin-bottom: 20px;
    padding: 24px;
    padding-bottom: 8px;
    background: url('https://pic3.zhuanstatic.com/zhuanzh/1f67f3ec-35f9-47ee-9898-3c86204fc135.png')
      no-repeat top left;
    background-size: 100% 100%;
    border-radius: 12px;
    .equation {
      position: relative;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-top: 6px;
      padding-left: 24px;
      color: #ff483c;
      font-weight: 500;
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      border-radius: 6px;

      .reduce {
        position: relative;
        top: -2px;
        margin: 0 18px;
      }

      em {
        font-size: 18px;
      }
      .receive-coupons {
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 82px;
        height: 36px;
        margin-bottom: 15px;
        color: #ff483c;
        font-size: 22px;
        line-height: 1;
        &::after {
          @include hairline(#ff2d2c);
          border-width: 1px;
          border-radius: 64px;
        }
      }
    }

    &__super {
      display: inline-flex;
      height: auto;
      margin: 0;
      margin-right: 8px;
      padding: 0;
      padding-left: 0;
      background: none;
      .seckill-time {
        display: inline-flex;
        display: flex;
        align-items: center;
        height: 36px;
        padding: 0 8px;
        color: #ff483c;
        font-weight: 500;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        background: linear-gradient(40deg, #ffeaee 0%, #fff0e5 100%);
        border-radius: 6px;
      }
    }
  }

  .old-to-new__content {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 12px;
    margin-left: 26px;
    padding-top: 9px;

    .dashed {
      position: relative;
      top: -1px;
      width: 1px;
      height: 18px;
      margin: 0 20px;
      margin-top: 6px;
      &::after {
        @include hairline(#fad5d7);
        border-left-width: 1px;
      }
    }

    &::before {
      position: absolute;
      top: 0;
      width: 100%;
      height: 1px;
      background: url('https://pic5.zhuanstatic.com/zhuanzh/867ce36c-5e27-41eb-af1c-d5dc0409d1dc.png')
        no-repeat top center;
      background-size: 100% 100%;
      content: '';
    }

    .tag-info {
      display: flex;
      align-items: center;
      margin-left: 0;
      padding: 0;
      color: #ff483c;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      &::after {
        border: none;
      }
      .tag-name {
        padding-right: 0;
      }
      .right-icon {
        width: 10px;
        height: 18px;
        margin-left: 6px;
      }
      .receive {
        padding-left: 16px;
        color: #ff483c;
        font-weight: 400;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        &::after {
          border: none;
        }
      }
    }
  }

  .tag-info {
    position: relative;
    display: inline-flex;
    align-items: center;
    align-self: baseline;
    height: 36px;
    margin-left: 8px;
    padding: 0 12px;
    color: #ff483c;
    font-weight: 400;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    &::after {
      @include hairline(#ff9f99);
      border-width: 1px;
      border-radius: 8px;
      opacity: 0.35;
    }

    .tag-name {
      padding-right: 10px;
    }
    .receive {
      position: relative;
      display: flex;
      align-items: center;
      height: 20px;
      padding-left: 12px;
      font-weight: 300;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      &::after {
        @include hairline(#ffcfc1);
        border-left-width: 1px;
        border-left-style: dashed;
      }
    }
  }

  .coupon-tip {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 8px;
    padding: 0 12px;
    color: #ff483c;
    font-weight: 400;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    &::after {
      @include hairline(#ffcfc1);
      border-width: 1px;
      border-radius: 8px;
    }
    .icon_couponTipContent {
      width: 20px;
      height: 20px;
    }
    span {
      margin: 0 4px;
    }
    .icon_arrow {
      width: 10px;
      height: 18px;
    }
  }
}
</style>
